<template>
<div>
    <label :for="idAttr" class="pb-3 block uppercase text-base font-medium">
        {{ label }}
    </label>
    <textarea
        class="text-gray-700 rounded-xl border border-gray-300 leading-normal resize-none w-full py-2 px-3 font-medium placeholder-gray-400"
        :placeholder='placeholder'
        :value="modelValue"
        rows="4"
        :id="idAttr"
        :name="idAttr"
        @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
</div>
</template>

<script>
export default {
    props: {
        placeholder: {
            default: '',
            type: String
        },
        label: String,
        modelValue: {
            required: true
        },
        idAttr: {
            required: true,
            type: String
        },
        translations: Object
    },
    emits: ['update:modelValue'],
}
</script>

<style scoped>
textarea:focus {
    box-shadow: none;
}
</style>
